<script setup>
import { computed } from 'vue';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';
import WgptActivity from './WgptActivity.vue';

const { content, createdAt, wgptAttributes } = useMessageContext();

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a')
);

const isWgptToolActivity = computed(() => {
  return (
    wgptAttributes.value &&
    ['tools_result', 'tools_use'].includes(wgptAttributes.value.operation)
  );
});
</script>

<template>
  <WgptActivity v-if="isWgptToolActivity" />
  <BaseBubble
    v-else
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span :title="content">{{ content }}</span>
  </BaseBubble>
</template>
